export class ForgotPasswordModel {
    Email: string;
}